const React = require('react');
const PropTypes = require('prop-types');
const DataTable = require('components/charts/DataTable/DataTable');
const DataTableColumn = require('components/charts/DataTableColumn/DataTableColumn');
const { formatText } = require('core/i18n').i18n;
const { formatValue } = require('../utilities/valueFormater');

const CountryExposureTable = ({ data, onMouseEnterRow }) => (
    <DataTable
        data={data}
        onMouseEnterRow={({ type: id }) =>
            onMouseEnterRow && onMouseEnterRow(id)
        }
    >
        <DataTableColumn
            dataKey="type"
            header={formatText('fundsCard-countryLabel').toUpperCase()}
        />
        <DataTableColumn
            dataKey="value"
            format={v => `${formatValue(Number(v).toFixed(2))}%`}
            header={formatText('fundsCard-percentage').toUpperCase()}
        />
        <DataTableColumn
            dataKey="benchmark"
            format={v => `${formatValue(Number(v).toFixed(2))}%`}
            header={formatText('fundsCard-benchmark').toUpperCase()}
        />
    </DataTable>
);

CountryExposureTable.propTypes = {
    data: PropTypes.array.isRequired,
    onMouseEnterRow: PropTypes.func,
};

module.exports = CountryExposureTable;
